import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BLOGS, getBlogExcerpt } from '../../data/blogs/index';
import '../../styles/Blogs.css';

const BlogApp = () => {
  const navigate = useNavigate();

  const sortedBlogs = useMemo(
    () => [...BLOGS].sort((a, b) => Number(b.featured) - Number(a.featured)),
    []
  );

  const [activeSlug, setActiveSlug] = useState(sortedBlogs[0]?.slug || '');
  const activeBlog = sortedBlogs.find((blog) => blog.slug === activeSlug) || sortedBlogs[0] || null;

  return (
    <div className="blog-editorial-shell">
      <div className="blog-editorial-header">
        <div>
          <p className="blog-editorial-kicker">Writing</p>
          <h2 className="blog-editorial-title">Field notes, essays, and the why behind the build.</h2>
          <p className="blog-editorial-copy">
            Every post is selected like a cover story, the strongest ideas get the center spread, the rest stay in the side rail.
          </p>
        </div>
        <div className="blog-editorial-count">{sortedBlogs.length} essays</div>
      </div>

      <div className="blog-editorial-layout">
        {activeBlog && (
          <button type="button" className="blog-editorial-feature" onClick={() => navigate(activeBlog.redirectUrl)}>
            <div className="blog-editorial-feature-top">
              <span className="blog-editorial-chip">{activeBlog.kicker}</span>
              <span className="blog-editorial-meta">{activeBlog.date} · {activeBlog.readTime}</span>
            </div>
            <h3 className="blog-editorial-feature-title">{activeBlog.title}</h3>
            <p className="blog-editorial-feature-copy">{activeBlog.summary || getBlogExcerpt(activeBlog)}</p>
            <div className="blog-editorial-tags">
              {activeBlog.tags?.slice(0, 4).map((tag) => (
                <span key={tag} className="blog-editorial-tag">{tag}</span>
              ))}
            </div>
            <span className="blog-editorial-cta">Open essay ↗</span>
          </button>
        )}

        <div className="blog-editorial-rail">
          {sortedBlogs.map((blog, index) => {
            const active = blog.slug === activeSlug;
            return (
              <button
                key={blog.slug}
                type="button"
                className={`blog-editorial-item${active ? ' active' : ''}${blog.featured ? ' featured' : ''}`}
                onClick={() => setActiveSlug(blog.slug)}
              >
                <span className="blog-editorial-item-index">0{index + 1}</span>
                <span className="blog-editorial-item-body">
                  <span className="blog-editorial-item-title">{blog.title}</span>
                  <span className="blog-editorial-item-copy">{blog.summary || getBlogExcerpt(blog)}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="blog-editorial-note">
        <p>Each essay opens on its own route and includes the full article, anchored sections, and supporting images.</p>
      </div>
    </div>
  );
};

export default BlogApp;
